import {
  ControlcenterMelcoModelsPaymentListItem,
  PaymentsApi,
  useAPIQuery,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";
import { useTable } from "../table/useTable";
//import { ALL_ORDER_SESSION_STATUS, OrderProductionStatus, OrderSessionStatus } from "../../helper/paymentsHelper";
//import { PaymentsListFiltersType } from "./PaymentsListFiltersType";
import { useTableErrorComponent } from "../table/useTableErrorComponent";

//const DEFAULT_SESSION_STATUS_FILTER = ALL_ORDER_SESSION_STATUS;

export const usePayments = () => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    currentPage,
    pageSize,
    sortBy,
  } = useTable<ControlcenterMelcoModelsPaymentListItem, any>({
    pageSizeOptions: [10, 20],
    pageSize: 20,
  });

  //const baseApiConfig = useBaseAPIConfig();
  console.log("FILTERS ", JSON.stringify(filters))
  const query = useAPIQuery(
    PaymentsApi,
    ["payments", currentPage, pageSize, filters, sortBy()],
    async (api) => {
      let response;
      response = await api.paymentsSearch({
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        sortBy: sortBy(),
        productList:
          filters?.products && !isEmpty(filters.products)
            ? filters.products
            : "",
        userName:
          filters?.userName && !isEmpty(filters.userName)
            ? filters.userName
            : "",

        searchText:
          filters?.searchText && !isEmpty(filters.searchText)
            ? filters?.searchText
            : "",

        statusList:
          filters?.statusList && !isEmpty(filters.statusList)
            ? filters.statusList.join(",")
            : undefined,
        serviceEndDate: filters?.serviceEndTimeStamp
          ? filters.serviceEndTimeStamp
          : undefined,
        serviceStartDate: filters?.serviceStartTimeStamp
          ? filters.serviceStartTimeStamp
          : undefined,
        transactionDate: filters?.transactionTimeStamp
          ? filters.transactionTimeStamp
          : undefined,
        melcoCustomerId: filters?.melcoCustomerId && !isEmpty(filters?.melcoCustomerId)
          ? filters.melcoCustomerId
          : undefined,
        affiliateList: filters?.affiliateList && !isEmpty(filters?.affiliateList)
          ? filters.affiliateList
          : undefined,
        paymentMode: filters?.paymentMode && !isEmpty(filters?.paymentMode)
          ? filters.paymentMode.join(",")
          : undefined,
        orgUnit: filters?.orgUnit && !isEmpty(filters?.orgUnit)
          ? filters.orgUnit.join(",")
          : undefined
      });
      //}

      setTotal(response?.total ? response?.total : 0);

      return response?.list ? response?.list : [];
    },
    {
      queryOptions: {
        // keepPreviousData: true,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    errorComponent,
    ...query,
  };
};